<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title" *ngIf="!isInvoice">
                {{'Confirm receipt print'|translate}}

                <span *ngIf="order.customer">
                    {{'for customer'|translate}} {{order.customer.firstName}} {{order.customer.lastName}} {{order.customer.phone}}
                </span>
            </span>
            <span class="title dialog-title" *ngIf="isInvoice">
                {{'Confirm invoice print'|translate}}

                <span *ngIf="order.customer">
                    {{'for customer'|translate}} {{order.customer.firstName}} {{order.customer.lastName}} {{order.customer.phone}}
                </span>
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <div class="invoice tab-content" fusePerfectScrollbar>

            <div id="invoice" class="compact page-layout blank" fxLayout="row" fusePerfectScrollbar>

                <div class="invoice-container">

                    <!-- INVOICE -->
                    <div class="card">
                        <table class="simple invoice-table">
                            <thead>
                            <tr>
                                <th>{{'PRODUCT'|translate}}</th>
                                <th class="text-right">{{'REGULAR PRICE'|translate}}</th>
                                <th class="text-right">{{'PRICE'|translate}}</th>
                                <th class="text-right">{{'QUANTITY'|translate}}</th>
                                <th class="text-right">{{'TOTAL'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of order.items">
                                <td>
                                    <div class="title">
                                        {{item.product.name}}
                                    </div>
                                </td>
                                <td class="text-right">
                                    {{item.priceGrossBeforeDiscount}}
                                </td>
                                <td class="text-right">
                                    {{item.priceGross}}
                                </td>
                                <td class="text-center">
                                    {{item.quantity}}
                                </td>
                                <td class="text-right">
                                    {{item.priceGross * item.quantity}}
                                </td>
                            </tr>
                            <tr *ngFor="let item of order.vouchers">
                                <td>
                                    <div class="title">
                                        {{item.voucherTemplate.name}}
                                    </div>
                                </td>
                                <td class="text-right">
                                    {{item.priceGrossBeforeDiscount}}
                                </td>
                                <td class="text-right">
                                    {{item.priceGross}}
                                </td>
                                <td class="text-center">
                                    {{item.quantity}}
                                </td>
                                <td class="text-right">
                                    {{item.priceGross * item.quantity}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

<!--        <pre>{{order|json}}</pre>-->
<!--        <table>-->
<!--            -->
<!--        </table>-->
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close('confirm')"
                aria-label="Confirm"
        >
            {{'Confirm'|translate}}
        </button>

    </div>
</div>
